import css from './NotificationDot.module.css'

const NotificationDot = () => {
    return <span className={css.dot} />
}

export default NotificationDot
